import { type DocumentListRow } from "~/features/orders/orderList/useOrderListState";
import type { OrderData } from "~/domains/orders/types/modelsV2";

export enum OrderDataSort {
  SO = "so",
  PO = "po",
  Account = "acc",
  DatePlaced = "date",
  OrderStatus = "status",
  TotalPrice = "price",
}

export const ORDER_DATA_SORT_HANDLERS: Dict<(a: DocumentListRow<OrderData>, b: DocumentListRow<OrderData>) => number> =
  {
    [OrderDataSort.SO]: (a, b) => a.data.soNumber.localeCompare(b.data.soNumber),
    [OrderDataSort.PO]: (a, b) => a.data.poNumber.localeCompare(b.data.poNumber),
    [OrderDataSort.Account]: (a, b) => {
      let result = a.data.account?.name?.localeCompare(b.data.account?.name ?? "");
      if (!result) {
        result = a.data.account?.endCustomerName?.localeCompare(b.data.account?.endCustomerName ?? "");
      }
      return result ?? 0;
    },
    [OrderDataSort.DatePlaced]: (a, b) => {
      const aTime = a.data.datePlaced?.getTime() ?? 0;
      const bTime = b.data.datePlaced?.getTime() ?? 0;
      return aTime - bTime;
    },
    [OrderDataSort.OrderStatus]: (a, b) => a.data.orderStatus.localeCompare(b.data.orderStatus),
    [OrderDataSort.TotalPrice]: (a, b) => a.data.totalPrice.value - b.data.totalPrice.value,
  };
